if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        /* SlideCart hijacks the click event with stopImmediatePropagation,
           so addEventListener('click') never fires. Use mousedown instead —
           it fires before the click and SlideCart doesn't block it. */
        this.submitButton.addEventListener('mousedown', () => {
          const span = this.submitButton.querySelector('span');
          if (!span) return;
          const original = span.textContent;
          span.textContent = 'Adding...';
          setTimeout(() => { span.textContent = original; }, 1500);
        });
      }

      onSubmitHandler(evt) {
        /* Upload-your-own products submit natively (full-page multipart POST) so
           Shopify can store the file line-item property — the AJAX /cart/add
           endpoint doesn't accept file uploads. */
        if (this.dataset.nativeSubmit === 'true') return;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        /* Show "Adding..." text instead of the default spinner overlay */
        this._btnSpan = this.submitButton.querySelector('span');
        if (this._btnSpan) {
          this._savedText = this._btnSpan.textContent;
          this._btnSpan.textContent = 'Adding...';
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        /* rAF + setTimeout forces the browser to paint "Adding..." before
           the fetch fires and SlideCart takes over the screen. */
        requestAnimationFrame(() => {
          setTimeout(() => {
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                /* Restore original button text */
                if (this._btnSpan && this._savedText) {
                  this._btnSpan.textContent = this._savedText;
                }
              });
          }, 0);
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
